// AuthUtils.js
// Helper functions for API calls and authentication

// Obfuscated keys for sessionStorage to make snooping harder
const KEYS = {
  USER_ID: '_v_uid',
  USER_TYPE: '_v_ut',
  TOKEN: '_v_tkn',
  PHONE: '_v_pn'
};

export const sendOTP = async (phoneNumber) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    "user_type": "vehicle_owner",
    "phone_number": phoneNumber
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  try {
    const response = await fetch("https://api.rtoxpert.com/api/users/select-type", requestOptions);
    const result = await response.json();
    return { success: response.ok, data: result };
  } catch (error) {
    console.error("Error sending OTP:", error);
    return { success: false, error: error.message };
  }
};

export const verifyOTP = async (phoneNumber, otp) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    "phone_number": phoneNumber,
    "otp": otp
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  try {
    const response = await fetch("https://api.rtoxpert.com/api/users/verify-otp", requestOptions);
    const result = await response.json();
    return { success: response.ok, data: result };
  } catch (error) {
    console.error("Error verifying OTP:", error);
    return { success: false, error: error.message };
  }
};

export const storeUserData = (userData) => {
  sessionStorage.setItem(KEYS.USER_ID, userData.user_id);
  sessionStorage.setItem(KEYS.USER_TYPE, userData.user_type);
  sessionStorage.setItem(KEYS.TOKEN, userData.token);
};

export const getUserData = () => {
  return {
    user_id: sessionStorage.getItem(KEYS.USER_ID),
    user_type: sessionStorage.getItem(KEYS.USER_TYPE),
    token: sessionStorage.getItem(KEYS.TOKEN)
  };
};

export const isAuthenticated = () => {
  return !!sessionStorage.getItem(KEYS.TOKEN);
};

export const getToken = () => {
  return sessionStorage.getItem(KEYS.TOKEN);
};

export const logout = () => {
  sessionStorage.removeItem(KEYS.USER_ID);
  sessionStorage.removeItem(KEYS.USER_TYPE);
  sessionStorage.removeItem(KEYS.TOKEN);
  sessionStorage.removeItem(KEYS.PHONE);
};

// Use this for API calls that require authentication
export const authFetch = async (url, options = {}) => {
  const token = sessionStorage.getItem(KEYS.TOKEN);

  if (!token) {
    throw new Error('No authentication token found');
  }

  const headers = new Headers(options.headers || {});
  headers.append('Authorization', `Bearer ${token}`);

  const requestOptions = {
    ...options,
    headers
  };

  return fetch(url, requestOptions);
};